export default __webpack_public_path__ + "static/media/EM0999.34I-41717_-25011_0.72f21dc5.jpg";